import { Card, Flex, Group, Text, Title } from "@mantine/core";
import { IMinUserDepricated, INotification } from "@mctypes/global.types";
import React from "react";
import { ISSUE_STATES_OPTIONS } from "../../app/routes/issuesApp/issueConstants";
import Avatar from "../Avatar";
import IconToggle from "../IconToggle/IconToggle";
import "./NotificationCard.css";

const NotificationCard: React.FC<{
  notification: INotification;
  onCardClick: (notification: INotification) => void;
  toggleMarkedAsRead: (notification: INotification) => void;
}> = ({ notification, onCardClick, toggleMarkedAsRead }) => {
  const date = new Intl.DateTimeFormat("nb-NO", { dateStyle: "full", timeStyle: "short" }).format(
    new Date(notification.createdAt),
  );
  const formattedDate = date.charAt(0).toUpperCase() + date.slice(1);

  const createdBy = notification.createdBy as IMinUserDepricated;
  const issueStatusOption = ISSUE_STATES_OPTIONS.find((status) => status.value === notification.issueStatus);

  const localMarkNotificationAsRead = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.stopPropagation();
    toggleMarkedAsRead(notification);
  };

  let message;
  switch (notification.typeOfNotification) {
    case "ASSIGNED":
      message = `${createdBy?.name ?? "Noen"} tildelte deg en sak.`;
      break;
    case "SUBSCRIBED":
      message = `${createdBy?.name ?? "Noen"} har endret en sak du abonnerer på.`;
      break;
    case "MENTION":
      message = `${createdBy?.name ?? "Noen"} har tagget deg i en melding.`;
      break;
    case "COMMENT_REACTION":
      message = `${createdBy?.name ?? "Noen"} reagerte på kommentaren din.`;
      break;
    case "MEMBER_ISSUE":
      message = `${createdBy?.name ?? "Noen"} har lagt deg til i en sak.`;
      break;
    case "MEMBER_MEETING":
      message = `${createdBy?.name ?? "Noen"} har lagt deg til i et møte.`;
      break;
    case "ASSIGNED_CHECKLIST":
      message = `${createdBy?.name ?? "Noen"} har lagt deg til som ansvarlig i en sjekkliste.`;
  }

  return (
    <Card
      className="onHover pointer"
      my={2}
      p="xs"
      radius="sm"
      withBorder
      flex="0 0 auto"
      onClick={() => onCardClick(notification)}
    >
      <Flex align="flex-start" gap="xs">
        <Group align="center" gap="xs" wrap="nowrap" flex={1}>
          <Avatar id={createdBy?._id} name={createdBy?.name} />
          <Title order={6} className="two-line-text-truncate" m={0}>
            {message}
          </Title>
        </Group>
        <IconToggle
          activeColor="#fcac62"
          toggled={!notification.markedAsRead?.value}
          activeIcon="envelope"
          inactiveIcon="envelope-open"
          onClick={localMarkNotificationAsRead}
        />
      </Flex>
      <Text className="two-line-text-truncate" mb="xs" mt={4}>
        {notification.text}
      </Text>
      {notification.issueStatus != null && (
        <Group align="center" gap="xs" mb="xs" wrap="nowrap">
          <span className="statusdot" style={{ backgroundColor: issueStatusOption?.color ?? "transparent" }} />
          <Text c="#58595B" size="xs">
            {notification.issueStatus.toUpperCase()}
          </Text>
        </Group>
      )}
      <Text mb={0} size="xs" c="dimmed">
        {formattedDate}
      </Text>
    </Card>
  );
};

export default NotificationCard;
